import axios from "../utils/axios";

export const postSparePartExcelToList = (payload) => {
    return axios.post(`/SpareParts/ExcelToList`, payload);
};


export const postSparePartExcelUpload = (payload) => {
    return axios.post(`/SpareParts/excel?fileCheckSum=${payload}`);
};

export const downloadSparePartExcel = () => {
    return axios.get(`/SpareParts/excel`, {
        responseType: "blob",
    });
};

export const downloadUnplannedExcelFile = (payload) => {
    return axios.post(`/UnplannedMaintenance/SparePartToExcelExport`, payload, {
        responseType: "blob",
    });
};

export const downloadPlannedExcelFile = (payload) => {
    return axios.post(`/PlannedMaintenance/SparePartToExcelExport`, payload, {
        responseType: "blob",
    });
};